import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Logo from "../images/logowebWhite.png";
import { QRCodeCanvas } from "qrcode.react";

function withRouter(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} navigate={navigate} location={location} />;
  };
}

class Footer extends React.Component {
  // ✅ WhatsApp link
  openWhatsApp = () => {
    const phoneNumber = "918848288848";
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  // ✅ Home scroll / navigate
  handleHomeClick = (e) => {
    e.preventDefault();
    const { navigate, location } = this.props;

    if (location?.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  // ✅ Testimonials scroll / navigate
  handleTestimonialsClick = (e) => {
    e.preventDefault();
    const { navigate, location } = this.props;

    if (location?.pathname === "/") {
      const section = document.getElementById("testimonials");
      section?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: "testimonials" } });
    }
  };

  // ✅ Contact scroll / navigate
  handleClickContact = (e) => {
    e.preventDefault();
    const { navigate, location } = this.props;

    if (location?.pathname === "/") {
      const contactSection = document.getElementById("contact_section");
      contactSection?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: "contact_section" } });
    }

    // ✅ Close mobile navbar if open
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector(".navbar-collapse.show");
    if (navbarCollapse) {
      navbarToggler.click();
    }
  };

  render() {
    return (
      <section className="info_section" id="contact_section">
        <div className="container">
          <div className="info_top">
            <div className="row">
              <div className="col-md-3">
                <NavLink className="navbar-brand" to="/">
                  <img width="200px" alt="logo" src={Logo} />
                </NavLink>
              </div>
              <div className="col-lg-3 mt-30">
                <div className="info_contact">
                  <div className="info_detail">
                    <p>
                      <a
                        href="tel:+918848288848"
                        className="nav-link"
                        style={{ fontSize: "25px", fontWeight: "500", color: "#fff" }}
                      >
                        <i className="fa fa-phone" aria-hidden="true" style={{ fontSize: "30px" }} />
                        &nbsp; +91 8848 28
                        8848
                      </a>
                    </p>
                    <p>
                      <i className="fa fa-envelope" aria-hidden="true" /> &nbsp;
                      info@yesedacademy.com
                    </p>
                  </div>
                </div>
              </div>


              <div className="col-md-4">
                <div className="social_box d-flex justify-content-center justify-content-md-end flex-wrap gap-4">
                  {/* WhatsApp */}
                  <div className="social-item text-center">
                    <NavLink className="nav-link" onClick={this.openWhatsApp}>
                      <i
                        className="fa fa-whatsapp"
                        aria-hidden="true"
                        style={{ color: "#25D366", fontSize: "26px" }}
                      />
                    </NavLink>
                    <QRCodeCanvas
                      value="https://wa.me/918848288848"
                      size={80}
                      bgColor="#ffffff"
                      fgColor="#56148a"
                      includeMargin={true}
                    />
                  </div>

                  {/* Instagram */}
                  <div className="social-item">
                    <NavLink
                      className="nav-link"
                      to="https://www.instagram.com/yesedacademy"
                      target="_blank"
                    >
                      <i
                        className="fa fa-instagram"
                        aria-hidden="true"
                        style={{ color: "#E1306C", fontSize: "30px" }}
                      />
                    </NavLink>
                    <QRCodeCanvas
                      value="https://www.instagram.com/yesedacademy"
                      size={80}
                      bgColor="#ffffff"
                      fgColor="#56148a"
                      includeMargin={true}
                    />
                  </div>
                  {/* Facebook */}
                  <div className="social-item text-center">
                    <NavLink
                      className="nav-link"
                      to="https://www.facebook.com/yesedacademy"
                      target="_blank"
                    >
                      <i
                        className="fa fa-facebook"
                        aria-hidden="true"
                        style={{ color: "#1877F2", fontSize: "26px" }}
                      />
                    </NavLink>
                    <QRCodeCanvas
                      value="https://www.facebook.com/yesedacademy"
                      size={80}
                      bgColor="#ffffff"
                      fgColor="#56148a"
                      includeMargin={true}
                    />
                  </div>
                 


                </div>
              </div>


            </div>
          </div>

          <div className="info_bottom">
            <div className="row mt-40">
              <div className="col-lg-3"></div>




              <div className="col-lg-4 col-md-6">
                <div className="info_detail">
                  <h5>
                    <i className="fa fa-map-marker" aria-hidden="true" /> &nbsp; Location
                  </h5>
                  <p>
                    1st Floor, Raj Arcade Building, <br />
                    Parakode P O, <br />
                    Adoor, Pathanathitta, <br />
                    Kerala, India. <br />
                    Pincode : 691554
                  </p>
                </div>
              </div>

              <div className="col-lg-2 col-md-6">
                <div>
                  <h5>Useful links</h5>
                  <ul className="info_menu">
                    <li>
                      <NavLink
                        className="nav-link"
                        to="/"
                        onClick={this.handleHomeClick}
                      >
                        Home
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="nav-link" to="/about">
                        About
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="nav-link" to="/services">
                        Services
                      </NavLink>
                    </li>
                    <li className="mb-0">
                      <NavLink
                        className="nav-link"
                        to="/contact"
                        onClick={this.handleClickContact}
                      >
                        Contact Us
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

// ✅ The key fix:
export default withRouter(Footer);
